module.exports = __webpack_public_path__ + "media/images/top-service-05-0f3f126f6361e7a8192afbe2edbf0c15.jpg";